import { countriesOptions } from '@/locale';
import { PAYIN_SCHOOL_SEGMENTS } from '@/constants/constants';

export const formFields = {
  address1: {
    label: 'Address line 1',
    id: 'address1',
    type: 'text',
  },
  address2: {
    label: 'Address line 2',
    id: 'address2',
    type: 'text',
  },
  address3: {
    label: 'Address line 3',
    id: 'address3',
    type: 'text',
  },
  town: {
    label: 'Town',
    id: 'town',
    type: 'text',
  },
  postcode: {
    label: 'Postcode',
    id: 'postcode',
    type: 'text',
  },
  jobTitle: {
    label: 'Job Title',
    id: 'jobTitle',
    type: 'text',
  },
  establishmentType: {
    label: 'Select organisation type', // Intentional! See DF-431 for more details
    id: 'establishmentType',
    description: 'Please choose',
    greyDescription: true,
    className: 'test-class',
    hideLabel: false,
    options: [
      { value: PAYIN_SCHOOL_SEGMENTS.NURSERY, displayValue: 'Nursery/Early Years Setting' },
      { value: PAYIN_SCHOOL_SEGMENTS.PRIMARY, displayValue: 'Primary School' },
      { value: PAYIN_SCHOOL_SEGMENTS.SECONDARY, displayValue: 'Secondary School' },
      { value: PAYIN_SCHOOL_SEGMENTS.COLLEGE, displayValue: 'College or Sixth Form' },
      { value: PAYIN_SCHOOL_SEGMENTS.YOUTH_GROUP, displayValue: 'Youth Group' },
    ],
  },
  establishmentName: {
    label: 'Organisation name', // Intentional! See DF-431 for more details
    id: 'establishmentName',
    type: 'text',
  },
  country: {
    label: 'Country',
    id: 'country',
    options: countriesOptions,
    type: 'text',
  },
};
